// extracted by mini-css-extract-plugin
module.exports = {"tmtLogo":"Logo_tmtLogo__3I7Y-","logoImg":"Logo_logoImg__tK49w","configuratorText":"Logo_configuratorText__y_bTu"};